import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import RouterComponent from "../components/RouterComponent.vue";
import store from "../store"
import { readIsLicenceAccepted } from "@/store/main/getters";


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "start" */ "../views/main/Start.vue"),
    children: [
      {
        path: "token",
        name:"token",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "token" */ "../views/Token.vue"),
      },
      {
        path: "login",
        name:"login",

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "login" */ "../views/Login.vue"),
      },
      {
        path: "recover-password",
        name:"recover-password",
        component: () =>
          import(
            /* webpackChunkName: "recover-password" */ "../views/PasswordRecovery.vue"
          ),
      },
      {
        path: "reset-password",
        name: "reset-password",
        component: () =>
          import(
            /* webpackChunkName: "reset-password" */ "../views/ResetPassword.vue"
          ),
      },
      {
        path: "main",
        name: "main",
        component: () =>
          import(/* webpackChunkName: "main" */ "../views/main/Main.vue"),
        children: [
          {
            path: "dashboard",
            name: "main-dashboard",
            component: () =>
              import(
                /* webpackChunkName: "main-dashboard" */ "../views/main/Dashboard.vue"
              ),
          },
          {
            path: "about",
            name: "main-about",
            component: () =>
              import(/* webpackChunkName: "main-about" */ "../views/About.vue"),
          },
          {
            path: "licence",
            name: "main-licence",
            component: () =>
              import(/* webpackChunkName: "main-licence" */ "../views/Licence.vue"),
          },
          {
            path: "miners",
            component: RouterComponent,
            redirect: "miners/all",
            children: [
              {
                path: "all",
                name: "main-miners",
                component: () =>
                  import(
                    /* webpackChunkName: "main-miners" */ "../views/main/miner/Miners.vue"
                  ),
              },
              {
                path: "miners/view/:id",
                name: "main-miners-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-miners-edit" */ "../views/main/miner/ViewMiner.vue"
                  ),
              },
              {
                path: "miners/remove/:id",
                name: "main-miners-remove",
                component: () =>
                  import(
                    /* webpackChunkName: "main-miners-edit" */ "../views/main/miner/ViewMiner.vue"
                  ),
              },
              {
                path: "miners/edit/:id",
                name: "main-miners-edit",
                component: () =>
                  import(
                    /* webpackChunkName: "main-miners-edit" */ "../views/main/miner/EditMiner.vue"
                  ),
              },
            ],
          },
          {
            path: "withdraws",
            component: RouterComponent,
            redirect: "withdraws/view",
            children: [
              {
                path: "view",
                name: "main-withdraw-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-miners" */ "../views/main/withdraw/Withdraws.vue"
                  ),
              },
              {
                path: "view/:id",
                name: "main-withdraw-view-one",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-confirm" */ "../views/main/withdraw/ViewWithdraw.vue"
                  ),
              },
              {
                path: "create/:id?",
                name: "main-withdraw-create",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-create" */ "../views/main/withdraw/CreateWithdraw.vue"
                  ),
              },{
                path: "transfer/:id?",
                name: "main-withdraw-transfer",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-transfer" */ "../views/main/withdraw/Transfer.vue"
                    ),
              },
              {
                path: "confirm/:id",
                name: "main-withdraw-confirm",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-confirm" */ "../views/main/withdraw/ConfirmWithdraw.vue"
                  ),
              },
              {
                path: "edit/:id",
                name: "main-withdraw-edit",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-edit" */ "../views/main/withdraw/EditWithdraw.vue"
                  ),
              },
              {
                path: "revert/:id",
                name: "main-withdraw-revert",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-revert" */ "../views/main/withdraw/RevertWithdraw.vue"
                  ),
              },
              {
                path: "settle/:id",
                name: "main-withdraw-settle",
                component: () =>
                  import(
                    /* webpackChunkName: "main-withdraws-settle" */ "../views/main/withdraw/SettleWithdraw.vue"
                  ),
              },
            ],
          },{
            path: "company",
            component: RouterComponent,
            redirect: "company/view",
            children: [
              {
                path: "all",
                name: "main-company-all",
                component: () =>
                  /* webpackChunkName: "main-company-all" */ import( "../views/main/company/Companies.vue" ),
              },{
                path: "view/:id",
                name: "main-company-view",
                component: () =>
                  /* webpackChunkName: "main-company-view" */ import( "../views/main/company/ViewCompany.vue" ),
              },{
                path: "create",
                name: "main-company-create",
                component: () =>
                  /* webpackChunkName: "main-company-create" */ import("../views/main/company/CreateCompany.vue"),
              }

            ],
          },{
            path: "incomes",
            component: RouterComponent,
            redirect: "incomes/view",
            children: [
              {
                path: "view",
                name: "main-income-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-income-view" */ "../views/main/income/Incomes.vue"
                    ),
              },
            ],
          },
          {
            path: "shares",
            name:"main-shares",
            component: () =>
              import(
                /* webpackChunkName: "main-miners" */ "../views/main/Shares.vue"
              ),
          },
          {
            path: "profile",
            component: RouterComponent,
            redirect: "profile/view",
            children: [
              {
                path: "view",
                name:"profile-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-profile" */ "../views/main/profile/UserProfile.vue"
                  ),
              },
              {
                path: "edit",
                name:"profile-edit",
                component: () =>
                  import(
                    /* webpackChunkName: "main-profile-edit" */ "../views/main/profile/UserProfileEdit.vue"
                  ),
              },
              {
                path: "password",
                name:"profile-password",
                component: () =>
                  import(
                    /* webpackChunkName: "main-profile-password" */ "../views/main/profile/UserProfileEditPassword.vue"
                  ),
              },
            ],
          },{
            path: "referral",
            name:"main-referral",
            component: () =>
              import(
                /* webpackChunkName: "main-referral" */ "../views/main/referral/Referral.vue"
                ),
          },
          {
            path: "admin",
            name:"admin",
            component: () =>
              import(
                /* webpackChunkName: "main-admin" */ "../views/main/admin/Admin.vue"
              ),
            redirect: "admin/users/all",
            children: [
              {
                path: "users",
                redirect: "users/all",
              },
              {
                path: "users/all",
                name:"admin-users-all",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-users" */ "../views/main/admin/AdminUsers.vue"
                  ),
              },
              {
                path: "users/view/:id",
                name: "main-admin-users-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-users-view" */ "../views/main/admin/ViewUser.vue"
                  ),
              },
              {
                path: "users/edit/:id",
                name: "main-admin-users-edit",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-users-edit" */ "../views/main/admin/EditUser.vue"
                  ),
              },
              {
                path: "users/create",
                name: "main-admin-users-create",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-users-create" */ "../views/main/admin/CreateUser.vue"
                  ),
              },
              {
                path: "wallets/create",
                name: "main-admin-wallets-create",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-wallets-create" */ "../views/main/admin/AdminCreateWallet.vue"
                  ),
              },
            ],
          },
          {
            path: "wallets",
            component: RouterComponent,
            redirect: "/all",
            children: [
              {
                path: "",
                redirect: "all",
              },
              {
                path: "all",
                name: "main-wallets-all",
                component: () =>
                  import(
                    /* webpackChunkName: "main-admin-users" */ "../views/main/wallet/UserWallets.vue"
                  ),
              },
              {
                path: "view/:id",
                name: "main-wallets-view",
                component: () =>
                  import(
                    /* webpackChunkName: "main-wallets-view" */ "../views/main/wallet/ViewWallet.vue"
                  ),
              },
              {
                path: "edit/:id",
                name: "main-wallets-edit",
                component: () =>
                  import(
                    /* webpackChunkName: "main-wallets-edit" */ "../views/main/wallet/EditWallet.vue"
                  ),
              },
              {
                path: "create",
                name: "main-wallets-create",
                component: () =>
                  import(
                    /* webpackChunkName: "main-wallets-create" */ "../views/main/wallet/CreateWallet.vue"
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach(async (to, from,next) => {
//   // if (to.name != 'token')
//     console.log("before ---- "+to.name + " "+store.state.main.isLicenceAccepted);
//   next();
// })

export default router;
